import { createRouter, createWebHashHistory } from 'vue-router'
import En from '../views/En.vue'
import Fr from '../views/Fr.vue'
import Es from '../views/Es.vue'
import De from '../views/De.vue'
import It from '../views/It.vue'
import Pt from '../views/Pt.vue'
import Nl from '../views/Nl.vue'
import Jp from '../views/Jp.vue'

import Language from '../views/Language.vue'

const routes = [
  {
    path: '/',
    name: 'En',
    component: En
  },
  {
    path: '/fr',
    name: 'Fr',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/Fr.vue')
  },
  {
    path: '/es',
    name: 'Es',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/Es.vue')
  },
  {
    path: '/de',
    name: 'De',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/De.vue')
  },
  {
    path: '/it',
    name: 'It',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/It.vue')
  },
  {
    path: '/pt',
    name: 'Pt',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/Pt.vue')
  },
  {
    path: '/nl',
    name: 'Nl',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/Nl.vue')
  },
  {
    path: '/jp',
    name: 'Jp',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/Jp.vue')
  }
]

const router = createRouter({
  history: createWebHashHistory(),
  routes
})

export default router
